/** Read a video file's duration in seconds from its metadata. */
export const readVideoDuration = (file: File): Promise<number> =>
	new Promise((resolve, reject) => {
		const url = URL.createObjectURL(file);
		const video = document.createElement("video");
		video.preload = "metadata";
		video.onloadedmetadata = () => {
			URL.revokeObjectURL(url);
			resolve(video.duration);
		};
		video.onerror = () => {
			URL.revokeObjectURL(url);
			reject(new Error(`Could not read metadata for ${file.name}`));
		};
		video.src = url;
	});

/**
 * PUT a file to a presigned S3 URL, reporting progress 0–100. XHR rather than
 * axios's client: the upload goes straight to S3, without the API's auth and
 * organization headers.
 */
export const uploadToPresignedUrl = (
	file: File,
	presignedUrl: string,
	onProgress: (percent: number) => void,
): Promise<void> =>
	new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest();
		xhr.upload.addEventListener("progress", (event) => {
			if (event.lengthComputable) {
				onProgress(Math.round((event.loaded / event.total) * 100));
			}
		});
		xhr.addEventListener("load", () => {
			if (xhr.status >= 200 && xhr.status < 300) resolve();
			else reject(new Error(`Upload failed with status ${xhr.status}`));
		});
		xhr.addEventListener("error", () =>
			reject(new Error("Network error during upload")),
		);
		xhr.open("PUT", presignedUrl);
		xhr.setRequestHeader("Content-Type", "video/mp4");
		xhr.send(file);
	});
